import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {CommonUtils} from '../utils/common';
import {VetineoApiResponse} from '../models/vetineo-api-response.model';
import {map} from 'rxjs/operators';
import {Observable} from "rxjs";
import {UserTag} from "../models/user-tag.model";

/**
 * Serwis warstwy danych obsługujący słownik etykiet (Tagów) użytkowników.
 * Służy do pobierania zdefiniowanych metadanych wykorzystywanych w procesach
 * segmentacji, kategoryzacji i profilowania pacjentów.
 */
@Injectable({
  providedIn: 'root'
})
export class UserTagsService {

  constructor(
    private apiService: ApiService,
    public commonUtils : CommonUtils,
  ) {
  }

  /**
   * Pobiera pełną, płaską listę dostępnych w systemie tagów.
   *
   * @returns Observable emitujący tablicę zinstancjonowanych obiektów etykiet (UserTag).
   */
  getTags(): Observable<UserTag[]> {
    return this.apiService.get<VetineoApiResponse>('/dashboard/user-tags').pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        return this.commonUtils.bestTypedArrayCopyEver(new UserTag(),[], vetineoApiResponse.response);
      } else {
        return undefined;
      }
    }));
  }

}
